export default __webpack_public_path__ + "static/media/POWER_RADAR.5abf335a.png";